<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M13 13a1 1 0 0 1 1 1v3.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V14a1 1 0 0 1 1-1Zm2.5-8A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-3a2 2 0 1 0-4 0v3H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79Zm-4 6a.5.5 0 0 0 0 1H13v-1h-1.5Zm1.5 0h1.5a.5.5 0 0 0 0-1H13v1Zm-1.5-2a.5.5 0 0 0 0 1H13V9h-1.5ZM13 9h1.5a.5.5 0 0 0 0-1H13v1Zm-1.5-2a.5.5 0 0 0 0 1H13V7h-1.5ZM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3h2.48Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v.54c0 .25-.2.46-.46.46h-3.08l-.1-.01a.46.46 0 0 1-.36-.45V17H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3h2.48ZM13 13a1 1 0 0 0-1 1v3h2v-3a1 1 0 0 0-1-1ZM8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H11v-2a2 2 0 1 1 4 0v2h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56ZM13 12h-1.5a.5.5 0 0 1 0-1H13v1Zm1.5-2a.5.5 0 0 1 0 1H13v-1h1.5ZM13 10h-1.5a.5.5 0 0 1 0-1H13v1Zm1.5-2a.5.5 0 0 1 0 1H13V8h1.5ZM13 8h-1.5a.5.5 0 0 1 0-1H13v1ZM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.75.75 0 0 0 6.98 4H4.5Z"
    />
  </svg>
</template>
